import React from "react";

const FileDown  = ({style = {}, size = "28", className = "", color = "currentColor", viewBox = "0 0 24 24", strokeWidth = 2}) => (
    <svg
        width={size}
        height={size}
        viewBox={viewBox}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        style={{...style, minWidth: size, minHeight: size}}
    >
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
        <path d="M12 12v6" />
        <path d="m9 15 3 3 3-3" />
    </svg>
);

export default FileDown;
